import React, { Component } from 'react';
// Stripe
import { StripeProvider } from 'react-stripe-elements';

class PaymentProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: null,
    };
  }

  componentDidMount() {
    const stripeApiKey = this.props.apiKey;
    if (!stripeApiKey) {
      throw new Error('An API key is required for the payment provider');
    }
    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(stripeApiKey) });
      return;
    }
    document.querySelector('#stripe-js').addEventListener('load', () => {
      // Create Stripe instance once Stripe.js loads
      this.setState({ stripe: window.Stripe(stripeApiKey) });
    });
  }

  render() {
    // this.state.stripe will either be null or a Stripe instance
    // depending on whether Stripe.js has loaded.
    const { stripe } = this.state;
    const { children } = this.props;
    return <StripeProvider stripe={stripe}>{children}</StripeProvider>;
  }
}

export default PaymentProvider;
